import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function Reembolsos() {
  return <LegalLayout title="Política de Reembolsos" data-id="element-333">
      <div className="space-y-6 text-muted-foreground font-light leading-relaxed" data-id="element-334">
        <p data-id="element-335">Última actualización: Mayo 2026</p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-336">
          1. Ventas Finales
        </h2>
        <p data-id="element-337">
          Debido a la naturaleza digital e intangible de nuestros productos
          (ebooks, guías y diarios en formato PDF), todas las ventas son
          finales. Una vez que la compra se ha completado y los enlaces de
          descarga han sido entregados, no es posible realizar devoluciones ni
          emitir reembolsos.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-338">
          2. Por qué mantenemos esta política
        </h2>
        <p data-id="element-339">
          A diferencia de los productos físicos, los archivos digitales no
          pueden ser "devueltos" una vez que han sido descargados o accedidos.
          Al realizar tu compra, aceptas esta condición. Te invitamos a leer
          detenidamente toda la información de la página de ventas para
          asegurarte de que esta experiencia es la adecuada para ti antes de
          comprar.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-340">
          3. Soporte Técnico
        </h2>
        <p data-id="element-341">
          Si bien no ofrecemos reembolsos, nuestro compromiso con tu experiencia
          es total. Si experimentas algún problema técnico, no recibes el correo
          de acceso, o tienes dificultades para descargar tus archivos, nuestro
          equipo de soporte está disponible para asistirte y garantizar que
          recibas todo el material por el que has pagado.
        </p>
        <p data-id="element-342">
          Puedes contactarnos en <strong data-id="element-343">hola@paolarojas.com</strong> y
          resolveremos cualquier inconveniente técnico a la brevedad posible.
        </p>
      </div>
    </LegalLayout>;
}